import {inject, Injectable} from '@angular/core';
import Keycloak from 'keycloak-js';
import {AuthService} from '../../guard/auth.service';
import {EntitlementsStore} from './entitlements.store';
import {TokenRefreshService} from '../../../config/services/token-refresh.service';
import {environment} from '../../../../environments/environment';

/**
 * Fin de session utilisateur. Purge complète de l'état par-utilisateur avant de rendre la main à
 * Keycloak : aucun résidu d'identité (currentUser, droits, tokens) ne doit subsister entre deux comptes
 * ou deux onglets/environnements partageant le navigateur.
 */
@Injectable({providedIn: 'root'})
export class SessionService {
  private readonly keycloak = inject(Keycloak);
  private readonly auth = inject(AuthService);
  private readonly entitlements = inject(EntitlementsStore);
  private readonly tokenRefresh = inject(TokenRefreshService);

  logout(): void {
    this.auth.clearUser();
    this.entitlements.clear();
    this.tokenRefresh.clearTokens();
    void this.keycloak.logout({redirectUri: environment.keycloak.logoutUrl});
  }
}
